var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingRoomValves = function SvgDHeatingRoomValves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 136,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 149,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "521.99 151.01 529.14 163.49 514.87 163.5 521.99 151.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.99,152.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M521.99,150l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "514.87 136.51 529.14 136.5 521.99 148.99 514.87 136.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.28,137l-6.29,10.98-6.26-10.98h12.55M530,136h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 501.01,
    cy: 150,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.01,140c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M501.01,139c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.42,147.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 323.02,
    y: 136,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.02,
    y: 149,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "328.01 151.01 335.15 163.49 320.88 163.5 328.01 151.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.01,152.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M328,150l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "320.88 136.51 335.15 136.5 328.01 148.99 320.88 136.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.29,137l-6.29,10.98-6.26-10.98h12.55M336.02,136h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 307.02,
    cy: 150,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.02,140c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M307.02,139c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.44,147.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })))));
};
export default SvgDHeatingRoomValves;